import { useSettings } from '@/data/Settings';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
	// envIs?: 'dev' | 'qa' | 'prod';
	children?: JSX.Element | JSX.Element[] | string | null;
};

export const ContainerTag: FC<Props> = ({ children }) => {
	const { settings } = useSettings();
	const containerTag = settings.containerTag;
	if (!containerTag) {
		return null;
	}
	const containerSplit: string[] = containerTag.split('-');
	const env = containerSplit[0];
	const date = `${containerSplit[1]}-${containerSplit[2]}-${containerSplit[3]}`;
	const time = `${containerSplit[4]}:${containerSplit[5]}:${containerSplit[6]}`;
	const hash = containerSplit[7];

	return env === 'dev' ? (
		<>
			<Typography variant="caption">
				{`Environment: ${env} | Date: ${date} | Time: ${time} | Hash: ${hash}`}
			</Typography>
			{children}
		</>
	) : (
		<>
			<Box
				data-testid="containerTag"
				dangerouslySetInnerHTML={{
					__html: `<!-- ${`Environment: ${env} | Date: ${date} | Time: ${time} | Hash: ${hash}`} -->`,
				}}
			></Box>
			{children}
		</>
	);
};
